const errorEx = require('error-ex');

module.exports = {
  InitialisationFailed: errorEx('InitialisationFailed')
};
